import { Auth2FaResendCodeResponse } from "../../../models/auth2FaData";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";

/**
 * Model for the Auth2FaResendCodeState
 * @param data: Auth2FaResendResponse - The data for resending the 2FA code
 * @param isLoading: boolean - Indicates if the resend request is in progress
 * @param isLoaded: boolean - Indicates if the resend request has been completed
 * @param isError: boolean - Indicates if there was an error during the resend request
 */
export interface Auth2FaResendCodeState {
  data: Auth2FaResendCodeResponse;
  isLoading: boolean;
  isLoaded: boolean;
  isError: boolean;
}

// Action types for resending the 2FA code
// These are used to manage the state of the 2FA code resend process in the Redux
export const AUTH_2FA_RESEND_CODE_REQUEST = "AUTH_2FA_RESEND_CODE_REQUEST";
export const AUTH_2FA_RESEND_CODE_FAILURE = "AUTH_2FA_RESEND_CODE_FAILURE";
export const AUTH_2FA_RESEND_CODE_SUCCESS = "AUTH_2FA_RESEND_CODE_SUCCESS";

// Action interfaces for resending the 2FA code
// These interfaces define the structure of the actions dispatched during the 2FA code resend process
export interface Auth2FaResendCodeRequestAction {
  type: typeof AUTH_2FA_RESEND_CODE_REQUEST;
}
export interface Auth2FaResendCodeFailureAction {
  type: typeof AUTH_2FA_RESEND_CODE_FAILURE;
}
export interface Auth2FaResendCodeSuccessAction {
  type: typeof AUTH_2FA_RESEND_CODE_SUCCESS;
  data: Auth2FaResendCodeResponse;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AppDispatch = ThunkDispatch<any, any, AnyAction>;

export type Auth2FaResendCodeActionTypes =
  | Auth2FaResendCodeRequestAction
  | Auth2FaResendCodeFailureAction
  | Auth2FaResendCodeSuccessAction;
